import { render, staticRenderFns } from "./SideBarOptions.vue?vue&type=template&id=3785403e&"
import script from "./SideBarOptions.vue?vue&type=script&lang=js&"
export * from "./SideBarOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports